<template>
  <div class="player" v-show="this.$store.state.basicPlayerVisibility">
    <!-- userAgent에 mobileApp 이 없으면 - 웹이면 - 플레이어를 보여준다 / 모바일 웹이면 안보이게 한다 by billy 2020.04.20       -->
    <div v-if="!isMobileApp">
      <div class="mini-player" v-show="mode === 'mini' && courseinfo.course_no > 0" v-bind:style="{bottom: miniPlayer.bottom}">
        <div class="title" @click="mode='basic'">
          <div class="word_comma_1">{{ courseinfo.course_name }}</div>
          <div v-if="courseinfo.lecture_div === '30'">{{ courseinfo.my_category_name + "(" + courseinfo.school_grade_name + ")" }}</div>
          <div v-else-if="courseinfo.lecture_div === '20'">{{ courseinfo.plan_subject_name + "(" + courseinfo.school_grade_name + ")" }}</div>
          <div v-else>{{ courseinfo.subject_name + "(" + courseinfo.school_grade_name + ")" }}</div>
        </div>
        <div class="icon-group">
          <img v-if="!playerInfo.isPlaying" src="/assets/common/mini-player/play.png" height="36" @click="playClickEvent" />
          <img v-else src="/assets/common/mini-player/pause.png" height="36" @click="playClickEvent" />
          <img src="/assets/common/mini-player/more.png" width="15" height="15" @click="mode='basic'" />
        </div>
      </div>
    </div>

    <div class="basic-player" v-show="mode === 'basic'">
      <div class="player-section" v-show="isCourseImage === true">
        <div class="close" @click="mode='mini'">
          <img src="/assets/player/close.png" width="24" height="12" />
        </div>
        <div class="player-tag">
          <div class="subject" v-if="courseinfo.lecture_div === '30'">{{ courseinfo.my_category_name }}</div>
          <div class="subject" v-else-if="courseinfo.lecture_div === '20'">{{ courseinfo.plan_subject_name }}</div>
          <div class="subject" v-else>{{ courseinfo.subject_name }}</div>
          <div class="school-grade school-hig" v-if="courseinfo.school_div === '99'">{{ courseinfo.school_grade_name | convertSchoolGrade }}</div>
          <div class="school-grade school-mid" v-else-if="courseinfo.school_div === '20'">{{ courseinfo.school_grade_name | convertSchoolGrade }}</div>
          <div class="school-grade" v-else>{{ courseinfo.school_grade_name | convertSchoolGrade }}</div>
          <div class="timer"><img src="/assets/player/player-image-open-timer.png" width="32" height="38" @click="clickPlayStop" /></div>
        </div>
        <div class="player-title">{{ courseinfo.course_name }}</div>
        <div class="player-teacher" v-if="courseinfo.lecture_div === '30'">
          <div class="name">{{ courseinfo.nickname }}</div>
        </div>
        <div class="player-teacher" v-else @click="teacherInfoEvent(courseinfo.user_no)">
          <div class="name">{{ courseinfo.teacher_name }}</div>
          <div class="section">{{ courseinfo.teacher_div_name }}</div>
        </div>
        <div class="player-photo">
          <div class="player-photo-btn"><img src="/assets/player/player-image-open-btn.png" width="40" height="23" @click="isCourseImage = false" /></div>
          <div class="course-photo">
            <img v-bind:src="courseinfo.thumb_url" />
          </div>
          <div class="viewer-layer">
            <div class="viewer">
              <img src="/assets/player/viewer.png" width="12" height="8" />
              <div class="count">{{ courseinfo.view_count }}</div>
            </div>
          </div>
        </div>
        <div class="player-function">
          <like interest-div="21" :related-no="this.courseinfo.course_no" />
          <push interest-div="20" :related-no="this.courseinfo.course_no" />
          <!-- 교안이 있을때만 -->
          <img v-show="courseinfo.tutorial_image_url !== null" src="/assets/player/doc.png" width="15" height="18" @click="showTutorial" />
          <!--                    <img src="/assets/player/download.png" width="18" height="18" @click="saveOfflie" />-->
          <img src="/assets/player/add-playlist.png" width="22" height="18" @click="playListCourse" />
        </div>

        <!-- userAgent에 mobileApp 이 없으면 - 웹이면 - 플레이어를 보여준다 / 모바일 웹이면 안보이게 한다 by billy 2020.04.20       -->
        <div v-if="!isMobileApp">
          <div class="player-basic">
<!--            <vue-plyr :options="playerOptions" ref="plyr" id="player"-->
<!--                      @timeupdate="videoTimeUpdated" @playing="nowPlaying" @ready="playerReady" @pause="updatePaused"-->
<!--                      :emit="['ready','timeupdate','playing']">-->
<!--              <audio :src="courseinfo.audio_url" format="audio/mp3" @ended="playEnd"></audio>-->
<!--            </vue-plyr>-->

            <div class="button-group">
              <div class="repeat">
                <img v-if="!playerInfo.isRepeat" src="/assets/player/repeat.png" width="17" height="20" @click="repeatClickEvent" />
                <img v-if="playerInfo.isRepeat" src="/assets/player/repeat-active.png" width="17" height="20" @click="repeatClickEvent" />
              </div>
              <div class="backward">
                <img src="/assets/player/backward.png" width="30" height="16" @click="backwardClickEvent" />
              </div>
              <div v-if="!playerInfo.isPlaying" class="play" @click="playClickEvent">
                <img src="/assets/player/play.png" height="33" />
              </div>
              <div v-else class="pause" @click="playClickEvent">
                <img src="/assets/player/pause.png" height="33" />
              </div>
              <div class="forward">
                <img src="/assets/player/forward.png" width="30" height="16" @click="forkwardClickEvent"/>
              </div>
              <div class="speed" @click="changeSpeed">
                <img v-if="playerInfo.speed === 0.5" src="/assets/player/0.5x.png" width="18" height="20" />
                <img v-if="playerInfo.speed === 1" src="/assets/player/1x.png" width="18" height="20" />
                <img v-if="playerInfo.speed === 1.5" src="/assets/player/1.5x.png" width="18" height="20" />
                <img v-if="playerInfo.speed === 2" src="/assets/player/2x.png" width="18" height="20" />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="player-section-mini" v-show="isCourseImage === false">
        <div class="section-mini-button">
          <img src="/assets/player/player-image-close-timer.png" width="32" height="27" @click="clickPlayStop" />
          <img src="/assets/player/player-image-close-btn.png" width="40" height="23" @click="isCourseImage = true" />
        </div>
        <div class="section-mini-title">
          <div class="section-mini-image">
            <img src="/assets/player/mini-section-image.png" width="57" height="53" />
          </div>
          <div class="section-mini-text">
            <div class="player-title">{{ courseinfo.course_name }}</div>
            <div class="player-teacher" v-if="courseinfo.lecture_div === '30'">
              <div class="name">{{ courseinfo.nickname }}</div>
            </div>
            <div class="player-teacher" v-else>
              <div class="name">{{ courseinfo.teacher_name }}</div>
              <div class="section">{{ courseinfo.teacher_div_name }}</div>
            </div>
          </div>
        </div>
      </div>

      <course-list ref="courseList" class="course-list" :course-no="this.courseinfo.course_no" v-if="!isSchedulePlay && (courseinfo.lecture_div === '10' || courseinfo.lecture_div === '20')" />
      <schedule-list ref="scheduleList" class="schedule-list" :course-no="this.scheduleCourseNo" :course-list="this.scheduleCourseList" v-if="isSchedulePlay && (courseinfo.lecture_div === '10' || courseinfo.lecture_div === '20')" />
      <!--<related-course ref="relatedCourse" class="related-course" :course-no="this.courseinfo.course_no" v-if="courseinfo.lecture_div === '10' || courseinfo.lecture_div === '20'" />-->
      <comment-list ref="commentList" :course-no="this.courseinfo.course_no" v-on:showReplyComment="showReplyComment" v-on:showReportComment="showReportComment" v-on:hideTutorial="hideTutorial" />
    </div>

    <!-- 플레이리스트 선택 ion-select (화면에는 숨김)-->
    <ion-select class="play-list-select" v-show="false" mode="ios" interface="action-sheet" cancel-text="취소" @ionChange="putPlayList($event.target.value)">
      <ion-select-option v-bind:value="0">플레이리스트에 담기</ion-select-option>
      <ion-select-option v-bind:value="list.playlist_no" v-for="(list, index) in myPlayListInfo" :key="index">{{ list.title }}</ion-select-option>
    </ion-select>

    <!-- 자동 종료 설정 ion-select (화면에는 숨김)-->
    <ion-select class="play-stop-select" v-show="false" mode="ios" interface="action-sheet" cancel-text="취소" @ionChange="putPlayStop($event.target.value)">
      <ion-select-option value="0">Disabled</ion-select-option>
      <ion-select-option value="300000">5분</ion-select-option>
      <ion-select-option value="900000">15분</ion-select-option>
      <ion-select-option value="1800000">30분</ion-select-option>
      <ion-select-option value="2700000">45분</ion-select-option>
      <ion-select-option value="3600000">60분</ion-select-option>
    </ion-select>

    <tutorial-viewer :course-no="this.courseinfo.course_no" v-show="mode === 'tutorial'"  v-on:hideTutorial="hideTutorial" />
    <reply-comment :comment-no="this.commentNo" v-show="mode === 'reply'" v-on:hideReplyComment="hideReplyComment" />
    <report-comment :comment-no="this.commentNo" :reply-no="this.replyNo" v-show="mode === 'report'" v-on:hideReportComment="hideReportComment" />
  </div>
</template>

<script>
import * as ajax from "../utils/ajax";
import * as alert from '../utils/alert'
import * as biz from '../utils/biz'
import * as utils from "../utils/utils";

import ReplyComment from "./comment/ReplyComment";
import ReportComment from "./comment/ReportComment";
import RelatedCourse from "./lecture/RelatedCourse";
import CourseList from "./lecture/CourseList";
import CommentList from "./comment/CommentList";

import Vue from 'vue';
import Like from "./interest/like";
import Push from "./interest/push";
import TutorialViewer from "./lecture/TutorialViewer";
import ScheduleList from "./lecture/ScheduleList";
// export const EventBus = new Vue();

const BACKWARD_SECOND_TIME = 30;
const FORWARD_SECOND_TIME = 30;

export default {
  name: 'AudioPlayer',
  components: {TutorialViewer, Push, Like, CommentList, CourseList, ScheduleList, RelatedCourse, ReplyComment, ReportComment},
  data() {
    return {
      mode:"basic",
      miniPlayer: {
        bottom: "56px"
      },
      courseinfo: {
        course_no: 0,
        lecture_div: "",
        course_name: "",
        subject_name: "",
        plan_subject_name: "",
        my_category_name: "",
        school_grade: "",
        school_grade_name: "",
        user_no: "",
        teacher_name: "",
        teacher_div_name: "",
        nickname: "",
        thumb_url: "",
        tutorial_image_url: "",
        audio_url: "",
        view_count: 0
      },
      commentNo: 0,
      replyNo: 0,
      isConnectWIFI: true,
      isCourseImage: true,
      isPlayStopTimer: false,
      isSchedulePlay: false,
      scheduleCourseNo: 0,
      scheduleCourseList: [],
      myPlayListInfo: [],
      isMobileApp: false,
      isRole:false,
      isShowGuide:false
    }
  },
  created() {
    // EventBus.$on("initcourseinfo", this.initcourseinfo);
    // EventBus.$on("stopMiniPlayer", this.stopMiniPlayer);
    // EventBus.$on("setMiniPlayer", this.setMiniPlayer);
    // EventBus.$on("initScheduleInfo", this.initScheduleInfo);
    //
    // // 추가 함수 콜 방법 by billy
    // EventBus.$on("playcourse", this.playCourse);
    // EventBus.$on("playend", this.playEnd);
  },
  mounted() {
    window.isConnectWIFI = this.receiveIsconnectWIFI;

    // 모바일 앱에서 호출되였는가? by billy
    // UserAgent에 'mobileApp' 이 이는지 확인해서 플래그를 만듬...
    this.isMobileApp = /(mobileApp)/i.test(window.navigator.userAgent);
  },
  methods: {
    limit2minuteGuide() {
      if (this.isShowGuide)
        return;
      this.isShowGuide = true;
      document.querySelector('ion-alert-controller').create({
         message:
            "<b>2분 미리듣기가 완료되었습니다.</b>\n\n앗! 정회원이 아니시군요 ㅠㅠ\n<b>이 강의는 정회원만 이용할 수 있어요.</b>\n지금 바로 이용권을 구매하고\n초중등 전학년 전과목 모든 콘텐츠를 무제한\n이용할 수 있는 <b>정회원만의 특별한 혜택</b>을 누려보세요!",
          buttons: [
            {
              text: "다음번에 할래요",
              role: "cancel",
              cssClass: "secondary",
              handler: () => {
                // console.log('Confirm Cancel');
              this.isShowGuide = false;
              },
            },
            {
              text: "이용권 종류 보러가기",
              handler: () => {
              this.isShowGuide = false;
                window.location = "/mypage/ticket";
              },
            },
          ],
          mode: "ios",
      }).then(alert => {
        alert.present();
      });
    },
    initcourseinfo(courseNo, runapp = false, mode = 'basic') {
      ajax.Get(this, "/api/contents/course/play/role/" + courseNo, function(ref, data) {
        if (data === "success")
          ref.isRole = true;
        else
          ref.isRole = false;
        ref.initPlayer(courseNo, runapp, mode);
      });
    },
    initPlayer(courseNo, runapp = false, mode) {
      // this.$store.state.basicPlayerVisibility = true;
      // LTE 에서 재생여부 체크
      const lteStreaming = this.$cookie.get("lteStreaming");
      this.isSchedulePlay = false;
      if (!lteStreaming && !this.isConnectWIFI) {
        alert.alertConfirm(this, "Data charges may apply if Wi-Fi is not connected.\nDo you want to play?", "확인", '취소', function(ref) {
          ref.$cookie.set("lteStreaming", true);
          ref.playCourse(courseNo, runapp, mode);
        });
      } else {
        this.playCourse(courseNo, runapp, mode);
      }
    },
    initScheduleInfo(courseNo, courseList, mode) {
      // this.$store.state.basicPlayerVisibility = true;

      // 교과진도 스케쥴 재생
      this.scheduleCourseNo = courseNo;
      this.scheduleCourseList = courseList;

      this.isSchedulePlay = true;
      this.playCourse(courseNo, false, mode);
    },
    playCourse(courseNo, runapp, mode) {
      if (!this.isMobileApp) {
        this.updatePlaytime();
        this.isBottom();
      }

      console.log('playCourse courseNo :' + courseNo);
      // 강의정보
      ajax.Get(this, "/api/contents/course/" + courseNo, function(ref, data) {
        ref.courseinfo.course_no = data.course_no;
        ref.courseinfo.lecture_div = data.lecture_div;
        ref.courseinfo.subject_name = data.subject_name;
        ref.courseinfo.plan_subject_name = data.plan_subject_name;
        ref.courseinfo.my_category_name = data.my_category_name;
        ref.courseinfo.school_div = data.school_div;
        ref.courseinfo.school_grade = data.school_grade;
        ref.courseinfo.school_grade_name = data.school_div_name + data.school_grade_name.replace(/학년/gi, "");
        ref.courseinfo.course_name = data.course_name;
        ref.courseinfo.user_no = data.user_no;
        ref.courseinfo.teacher_name = data.teacher_name;
        ref.courseinfo.teacher_div_name = data.teacher_div_name;
        ref.courseinfo.nickname = data.nickname;
        ref.courseinfo.thumb_url = data.thumb_url;
        ref.courseinfo.tutorial_image_url = data.tutorial_image_url;
        ref.courseinfo.audio_url = data.audio_url;
        ref.courseinfo.view_count = data.view_count;

        // Full 모드로 변경오청
        ref.mode = mode

        if (!ref.isMobileApp) {
          // 데이터를 불러오는 시간차 때문에 바로 재생이 않되여 타임슬림을 1초정도
          // TODO Event 로 해결
          setTimeout(function() { ref.$refs.basicPlayer.playClickEvent() }, 1000);

        }
        else
        {
          console.log('runapp :' + runapp);
          if (!runapp) {
            // Add Code - by billy
            // 네이티브로 플레이 관련 함수를 호출한다 by Billy
            // 넘길 파라메타에 accessToken을 추가해서 함수호출하며 넘긴다..
            var accessToken = ref.$cookie.get("accessToken");
            if (accessToken == null)
              accessToken = "";
            ref.courseinfo.accessToken = accessToken;

            console.log('deviceInfo :' + utils.deviceInfo());
            // 모바일에서 함수명 : playerFunc()
            switch(utils.deviceInfo()) {
              case "Android":
                if (ref.isSchedulePlay) {
                  const params = {
                    courseinfo: ref.courseinfo,
                    scheduleCourseList: ref.scheduleCourseList
                  };
                  window.listenApp.playCourseWithSchedule(JSON.stringify(params));
                } else {
                  console.log('ref.courseinfo :' + ref.courseinfo);
                  window.listenApp.playCourse(JSON.stringify(ref.courseinfo));
                }
                break;
              case "iOS":
                if (ref.isSchedulePlay) {
                  const params = {
                    courseinfo: ref.courseinfo,
                    scheduleCourseList: ref.scheduleCourseList
                  };
                  window.webkit.messageHandlers.playCourseWithSchedule.postMessage(params);
                } else
                  window.webkit.messageHandlers.playCourse.postMessage(ref.courseinfo);
                break;
            }
            // -- by billy
          }
        }
      });
      // 강의에대한 나의 평가정보 조회
      ajax.Post(this, "/api/contents/course/rate" ,{course_no: courseNo} , function(ref, data){
        ref.rate = data;
      });

      if (!this.isMobileApp) {
        // 조회 수 추가
        ajax.Put(this, "/api/contents/course/view/" + courseNo, null, null);

        if (biz.isLogin(this)) {
          // 내가 본 강의 추가
          ajax.Post(this, "/api/member/member/listen", {course_no: courseNo}, null);

          // 수강내역 추가
          const params = {
            course_no: courseNo,
            listen_div: "10"
          };
          ajax.Post(this, "/api/member/member/study", params, null);
        }
      }
    },
    // play time update
    // 현재 오디오를 재생하기 전에 전 강의재생을 업데이트
    updatePlaytime() {
      if (this.courseinfo.course_no === 0)
        return;


      const player = this.player();
      const currentTime = player.currentTime;

      const params = {
        course_no: this.courseinfo.course_no,
        summary_second: currentTime
      };
      ajax.Post(this, "/api/contents/course/time/summary", params, null);
    },
    // computed 함수에 넣어야 하나 palyer 에 오유가 발생
    // ref 로 참조한 경우는 computed 쓸 수 없는 듯 ...

    isBottom() {
      // 하단에 툴바가 있으면 그만큼 띄워서 보여줌.
      const footer = document.querySelector('div.footer-toolbar');
      if (!utils.isEmpty(footer)) {
        this.miniPlayer.bottom = "90px";
      } else {
        this.miniPlayer.bottom = "0";
      }
    },
    playEnd(evnet) {
      // 반복버튼이 활성화되여 있으면
      if (this.$refs.basicPlayer.isRepeat) {
        return;
      }

      this.$refs.basicPlayer.isPlaying = false;

      // Two Track 및 관련강의 재생
      if (this.isSchedulePlay) {
        this.$refs.scheduleList.playEnded();
      } else {
        this.$refs.courseList.playEnded();
      }
    },
    // 교안보기
    showTutorial() {
      this.mode = "tutorial";
    },

    hideTutorial() {
      this.mode = "basic";
    },

    // 답글창 호출
    showReplyComment(commentNo) {
      this.commentNo = commentNo;
      this.mode = "reply";
    },

    // 답글창 닫기
    hideReplyComment() {
      this.mode = "basic";
      this.$refs.commentList.refreshCommentList();
    },

    // 신고창 호출
    showReportComment(commentNo, replyNo) {
      this.commentNo = commentNo;
      this.replyNo = replyNo;
      this.mode = "report";
    },

    // 신고창 닫기
    hideReportComment() {
      this.mode = "basic";
    },

    // 오프라인 저장
    // saveOfflie() {
    //     // alert.alert("service is being prepared.", "확인");
    //
    //     if (!biz.isLogin(this)) {
    //         alert.alertLogin(this);
    //         return;
    //     }
    //
    //     // 다운로드 목록 불러오기
    //     switch(utils.deviceInfo()) {
    //         case "Android":
    //             window.listenApp.getAudioListPlayer();
    //             break;
    //         case "iOS":
    //             window.webkit.messageHandlers.getAudioListPlayer.postMessage();
    //             break;
    //     }
    // },

    // 저장된 오디오 목록
    // receiveOfflineAudioFileList(fileList) {
    //     if (fileList.length > 20) {
    //         alert.alert("최대 다운로드 갯수(20개)를 초과하였습니다.", "확인");
    //         return;
    //     }
    //
    //     this.$toasted.show("다운로드 중 입니다. 잠시만 기다려 주세요.", {
    //         theme: "bubble",
    //         position: "bottom-center",
    //         duration : 2000
    //     });
    //
    //     // 오디오파일 다운로드
    //     switch(utils.deviceInfo()) {
    //         case "Android":
    //             window.listenApp.saveAudio(this.courseinfo.audio_url, this.courseinfo.course_name, this.courseinfo.course_no);
    //             break;
    //         case "iOS":
    //             const params = this.courseinfo.audio_url + "||" + this.courseinfo.course_name + "||" + this.courseinfo.course_no;
    //             window.webkit.messageHandlers.saveAudio.postMessage(params);
    //             break;
    //     }
    // },
    // 다운로드 성공
    // receiveSaveAudio(message) {
    //     if (message === "success") {
    //         alert.alert("오프라인 저장이 완료되였습니다.", "확인");
    //     }
    //
    //     // 다운로드 내역 추가
    //     ajax.Post(this, "/api/member/member/download", {course_no: this.courseinfo.course_no}, null);
    // },
    // WIFI 연결여부
    receiveIsconnectWIFI(value) {
      this.isConnectWIFI = value;
    },
    // 플레이리스트 열기이
    playListCourse() {
      if (!biz.isLogin(this)) {
        alert.alertLogin(this);
        return;
      }

      this.getMyPlayList();
      const select = document.querySelector('.play-list-select');

      setTimeout(function() {
        select.value = '';
        select.click();
      }, 200);
    },
    // my playlist 가져오기
    getMyPlayList() {
      const params = {};
      ajax.Post(this, "/api/member/playlist/search", params, function(ref, data) {
        ref.myPlayListInfo = data;
      });
    },
    // 플레이리스트 추가
    addPlayList() {
      alert.alertPrompt(this, "플레이리스트 추가", "이름을 입력하세요", function(ref, data) {
        const params = {
          title: data["0"]
        };
        ajax.Post(ref, "/api/member/playlist/", params, function(ref, data) {
          alert.alert("등록되었습니다.", "확인");
          ref.playListCourse();
        });
      });
    },
    // 플레이리스트 담기
    putPlayList(playlist_no) {
      if (playlist_no === "0") {
        this.addPlayList();
      } else if (playlist_no !== "" && playlist_no !== null) {
        const params = {
          course_no: this.courseinfo.course_no,
          playlist_no: playlist_no
        };
        ajax.Post(this, "/api/member/playlist/detail", params, function (ref, data) {
          ref.isActive = data.my_count > 0;

          if (ref.isActive) {
            alert.alert("Added lecture.", "확인");
          } else {
            alert.alert("Added lectures deleted.", "확인");
          }
        });
      }
    },
    // 자동 종료 버튼
    clickPlayStop() {
      const select = document.querySelector('.player .play-stop-select');

      select.value = '';
      select.click();
    },
    // 자동 종료 설정
    putPlayStop(time) {
      if (time === "0") {
        this.isPlayStopTimer = false;
      } else if (time !== "" && time !== null) {
        this.isPlayStopTimer = true;

        setTimeout(() => {
          if(this.isPlayStopTimer) {
            this.player().pause();
            this.$refs.basicPlayer.isPlaying = false;
          }
        }, time);
      }
    },
    // 선생님 페지로 이동
    teacherInfoEvent(user_no) {
      const url = "/preview/teacher/info/" + user_no;
      this.mode = 'mini';
      this.$router.push(url);
    },
    setMiniPlayer() {
      this.mode = 'mini';
    },
    setBasicPlayer() {
      console.log('--------------haha----------------')
      this.mode = 'basic';
    },
    stopMiniPlayer() {
      this.player().pause();
      this.playerInfo.isPlaying = false;
      // this.$store.state.basicPlayerVisibility = false;
    }
  },
  computed: {
    playerOptions() {
      const options = {
        controls: ['progress','current-time','duration', 'volume'],
        storage: { enabled: true, key: 'plyr' }
        //autoplay: true
      };
      return options
    }
  },
  filters: {
    // Filter definitions
    minuteToStringFormat(value) {
      return utils.minuteToStringFormat(value);
    },
    thousandSeparator(value) {
      return utils.thousandSeparator(value);
    },
    convertSchoolGrade(value) {
      return utils.convertSchoolGrade(value);
    }
  }
}
</script>

<style lang="css">
@import '../css/plyr.css';
</style>

<style scoped lang="scss">
div.basic-player {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: white;
  z-index: 100;

  overflow-y: auto;
}

div.mini-player {
  position: fixed;
  left: 0;
  bottom: 56px;

  width: 100%;
  height: 53px;
  padding: 0 24px;
  background-color: #343030;
  opacity: 0.84;
  z-index: 100;

  display: flex;
  justify-content: space-between;
  align-items: center;

  div.title {
    width: 100%;
    div:first-child {
      font-size: $font-base14;
      color: white;
    }
    div:nth-child(2) {
      font-size: $font-base10;
      color: $primary-color;
    }
  }
  div.icon-group {
    width: 95px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

div.player-section {
  padding: 17px 24px 37px 24px;
  border-bottom: 2px solid $line-secondary-color;

  div.close {
    text-align: right;
  }
  div.player-tag {
    margin: 13px 0 0 42px;
    display: flex;
    justify-content: center;

    font-size: $font-base12;

    div.subject {
      margin-right: 3px;
      height: 22px;
      padding: 0 6px;
      border: 1px solid $fifth-color;
      border-radius: 22px;
      text-align: center;
      line-height: 20px;
      color: $fifth-color;
    }
    div.school-grade {
      height: 22px;
      padding: 0 6px;
      border: 1px solid $primary-color;
      border-radius: 22px;
      text-align: center;
      line-height: 20px;
      color: $primary-color;
    }
    div.school-grade.school-mid {
      border: 1px solid $sixth-color;
      color: $sixth-color;
    }
    div.school-grade.school-hig {
      border: 1px solid $font-fifth-color;
      color: $font-fifth-color;
    }
    div.timer {
      margin: -10px 0 0 10px;
    }
  }
  div.player-title {
    margin-top: 9px;
    font-weight: $font-weight500;
    text-align: center;
  }
  div.player-teacher {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    font-size: $font-base14;

    div.name {
      margin-right: 4px;
      color: #222222;
    }
    div.section {
      color: #27992a;
    }
  }
  div.player-photo {
    margin: 30px 16px 15px 16px;

    div.player-photo-btn {
      height: 23px;
      margin: 0 0 0 82%;
    }
    div.course-photo {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      overflow-y: hidden;
      border-radius: 2%;
    }
    div.viewer-layer {
      float: right;
      text-align: right;
      margin-right: 15px;

      div.viewer {
        position: relative;
        bottom: 40px;

        width: 44px;
        height: 21px;
        background-color: $fifth-color;
        border-radius: 21px;
        text-align: center;
        font-size: $font-base10;
        font-weight: $font-weight500;
        color: white;

        display: flex;
        align-items: center;
        justify-content: center;

        div.count {
          margin-left: 3px;
        }
      }
    }
  }
  div.player-function {
    clear:right;

    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  div.player-basic {
    margin-top: 50px;

    div.time {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      font-size: $font-base12;
      color: #1e212f;

      div.total-time {
        color: $font-third-color;
      }
    }
    div.button-group {
      clear: both;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

div.player-section-mini {
  padding: 24px 0 0 0;
  border-bottom: 2px solid $line-secondary-color;

  div.section-mini-button {
    display: flex;
    justify-content: space-between;
    padding: 0 24px 0 24px;

    img:last-child {
      margin: 4px 0 0 0;
    }
  }
  div.section-mini-title {
    padding: 18px 12px 12px 24px;
    background-color: #292f3d;

    display: flex;
    justify-content: flex-start;

    div.section-mini-image {
      margin: 0 15px 0 0;
    }
    div.section-mini-text {
      div.player-title {
        margin-top: 5px;
        font-weight: $font-weight700;
        color: #ffffff;
      }
      div.player-teacher {
        margin-top: 5px;
        display: flex;
        justify-content: flex-start;
        font-size: $font-base14;
        font-weight: $font-weight500;

        div.name {
          margin-right: 4px;
          color: #ffffff;
        }
        div.section {
          color: #80d610;
        }
      }
    }
  }
}

.related-course {
  border-bottom: 2px solid $line-secondary-color;
}
</style>
